import React, { useEffect } from "react";
import Container from "components/sections/container";
import { getGlobalData, getPageData } from "utils/api";
import Sections from "components/sections/sections";
import Seo from "components/Seo";
import { Mixpanel } from "utils/mixpanel";

const FaqPage = ({ global, metadata, sections, pageData }) => {
  // Merge default site SEO settings with page specific SEO settings
  if (!metadata?.shareImage?.data) {
    delete metadata.shareImage;
  }
  const metadataWithDefaults = {
    ...global.attributes.metadata,
    ...metadata,
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const trackPageHit = () => {
      Mixpanel.track(pageData.title);
    };
    trackPageHit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Seo metadata={metadataWithDefaults} />
      <Container className="my-8">
        <Sections sections={JSON.parse(sections)} />
      </Container>
    </>
  );
};

export default FaqPage;

export async function getServerSideProps() {
  const globalLocale = await getGlobalData("en");
  const pageData = await getPageData({ full_slug: "/resources/faq" });

  const { metadata, contentSections, ...pageExtraData } = pageData.attributes;

  if (!pageData) {
    return { props: {} };
  }

  return {
    props: {
      global: globalLocale,
      metadata,
      pageData: pageExtraData ?? {},
      sections: JSON.stringify(contentSections),
    },
  };
}
